"use strict";
/*
 * Thunderstorm is a full web app framework!
 *
 * Typescript & Express backend infrastructure that natively runs on firebase function
 * Typescript & React frontend infrastructure
 *
 * Copyright (C) 2020 Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./types"), exports);
__exportStar(require("./request-types"), exports);
__exportStar(require("./force-upgrade"), exports);
__exportStar(require("./consts"), exports);
__exportStar(require("./api"), exports);
__exportStar(require("./BaseHttpRequest"), exports);
__exportStar(require("./BaseHttpModule"), exports);
__exportStar(require("./backup/apis"), exports);
__exportStar(require("./backup/backup-types"), exports);
__exportStar(require("./backup/db-def"), exports);
//db-api-generator
__exportStar(require("./db-api-gen/apiV1"), exports);
__exportStar(require("./db-api-gen/apiV2"), exports);
__exportStar(require("./db-api-gen/apiV3"), exports);
__exportStar(require("./sync-env"), exports);
__exportStar(require("./archiving"), exports);
__exportStar(require("./app-config"), exports);
